<template>
  <el-dialog
    title="解析结果"
    :visible.sync="visible"
    width="30%"
    :modal="false"
    :close-on-click-modal="false"
    @close="$emit('update:visible', false)"
  >
    <div>
      <div v-for="(val, key, i) in data" :key="i">{{key}}： {{val}}</div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="$emit('update:visible', false)">关 闭</el-button>
    </span>
  </el-dialog>
</template>


<script>
export default {
  props: {
    visible: { type: Boolean, default: false },
    data: { type: Object, default: () => ({}) },
  },
}
</script>
